import type { IGenericPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import withAuthentication from '@on3/ui-lib/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/hocs/withValidUrl';
import { JoinPage } from 'components/GetRecruited/JoinPage';
import { PageWrapper } from 'components/Layouts/PageWrapper';
import { type GetServerSideProps } from 'next';

const RecruitsHome = ({ siteData, ...props }: IGenericPageProps) => {
  const filteredSiteData = {
    ...siteData,
    secondaryMenuData: null,
  };

  return (
    <PageWrapper
      description="On3 Recruits. Where Talent Meets Opportunity."
      hideAds
      siteData={filteredSiteData}
      title="On3 Recruits Home"
      {...props}
    >
      {/* Placeholder */}
      <JoinPage />
    </PageWrapper>
  );
};

export const getServerSideProps: GetServerSideProps<IGenericPageProps> = async (
  ctx,
) => {
  const recruitsSiteKey = 409;
  const siteData = await withValidUrl.isValid(ctx, recruitsSiteKey);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      pageType: 'recruits',
      siteData,
      userData,
      data: null,
    },
  };
};

export default withValidUrl(RecruitsHome);
